import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { state: String }

  dragover(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"
    this.element.classList.add("border-gold", "border-2", "bg-gold/10")
    this.element.classList.remove("border-dashed")
  }

  dragleave(_event) {
    this.element.classList.remove("border-gold", "border-2", "bg-gold/10")
    this.element.classList.add("border-dashed")
  }

  async drop(event) {
    event.preventDefault()
    this.element.classList.remove("border-gold", "border-2", "bg-gold/10")
    this.element.classList.add("border-dashed")

    const data = JSON.parse(event.dataTransfer.getData("application/json"))
    const { taskId, sourceState } = data
    const targetState = this.stateValue

    if (sourceState === targetState) {
      return
    }

    const taskElement = document.getElementById(`task_${taskId}`)
    if (taskElement) {
      const sourceColumn = taskElement.parentElement

      const targetEmptyMsg = this.element.querySelector("p.text-center")
      if (targetEmptyMsg) {
        targetEmptyMsg.remove()
      }

      this.element.prepend(taskElement)
      this.updateTaskIcon(taskElement, targetState)
      taskElement.dataset.taskDragStateValue = targetState

      if (sourceColumn && sourceColumn.querySelectorAll("[data-controller='task-drag']").length === 0) {
        const emptyMsg = document.createElement("p")
        emptyMsg.className = "font-mono text-xs text-cream/20 py-8 text-center"
        emptyMsg.textContent = this.emptyMessage(sourceState)
        sourceColumn.appendChild(emptyMsg)
      }
    }

    this.moveTask(taskId, targetState)
  }

  async moveTask(taskId, state) {
    const csrfToken = document.querySelector("meta[name='csrf-token']").content

    try {
      await fetch(`/tasks/${taskId}/move`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRF-Token": csrfToken
        },
        body: `state=${state}`
      })
    } catch (e) {
      console.error("Failed to move task", e)
    }
  }

  updateTaskIcon(taskElement, state) {
    const iconBtn = taskElement.querySelector("button span, form span")
    if (!iconBtn) return

    const icons = {
      pending: { class: "w-5 h-5 border border-cream/30 flex items-center justify-center text-cream/30 hover:border-gold hover:text-gold transition-colors font-mono text-xs", text: "" },
      in_progress: { class: "w-5 h-5 border border-gold bg-gold/10 flex items-center justify-center text-gold hover:bg-gold/20 transition-colors font-mono text-xs", text: ">" },
      completed: { class: "w-5 h-5 border border-cream/20 bg-cream/5 flex items-center justify-center text-cream/30 hover:border-cream/40 transition-colors font-mono text-xs", text: "x" },
      paused: { class: "w-5 h-5 border border-rose-dust bg-rose-dust/10 flex items-center justify-center text-rose-dust hover:bg-rose-dust/20 transition-colors font-mono text-xs", text: "||" }
    }

    const icon = icons[state]
    if (icon) {
      iconBtn.className = icon.class
      iconBtn.textContent = icon.text
    }

    const title = taskElement.querySelector("h3")
    if (title) {
      if (state === "completed") {
        title.classList.add("line-through", "text-cream/40")
      } else {
        title.classList.remove("line-through", "text-cream/40")
      }
    }

    const card = taskElement.querySelector(":scope > div")
    if (card) {
      card.classList.remove("opacity-50", "opacity-60")
      if (state === "completed") {
        card.classList.add("opacity-50")
      } else if (state === "paused") {
        card.classList.add("opacity-60")
      }
    }
  }

  emptyMessage(state) {
    const messages = {
      pending: "Sin tareas pendientes",
      in_progress: "Nada en progreso",
      completed: "Sin tareas completadas",
      paused: "Sin tareas pausadas"
    }
    return messages[state] || "..."
  }
}
